import { LogEntryCellModelData } from '../rows/log-entry/LogEntryCellModel';
import { LogEntryRowModelData } from '../rows/log-entry/LogEntryRowModel';
import { LogViewerTableModelData, LogViewerTableModelDataWithRows } from './LogViewerTableModel';

export const Reset = 'Reset';
export interface ResetArgs {
  data: LogViewerTableModelDataWithRows;
}

export const SyncTableModelChanges = 'SyncTableModelChanges';
export type SyncTableModelChangesArgs = {
  change: DeepPartial<LogViewerTableModelData>;
  postProcess: boolean;
};

export const SyncLogEntryRowChanges = 'SyncLogEntryRowChanges';
export type SyncLogEntryRowChangesArgs = {
  changes: {
    rowIndex: number;
    change: DeepPartial<LogEntryRowModelData>;
  }[];
  postProcess: boolean;
};

export const SyncLogEntryCellChange = 'SyncLogEntryCellChange';
export interface SyncLogEntryCellChangeArgs {
  rowIndex: number;
  cellIndex: number;
  change: DeepPartial<LogEntryCellModelData>;
  postProcess: boolean;
}
